if (!customElements.get('tq-campaign')) {
  customElements.define('tq-campaign', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.initGallery(options);
      this.initReviews(options);
      this.addEventListener('submit', e => {
        const form = e.target.closest('[data-tq-form]');
        if (!form) return;
        e.preventDefault();
        this.addItem(form);
      }, options);
      this.addEventListener('click', e => {
        const link=e.target.closest('[data-tq-open-cart],[data-tq-cart-recovery]');
        if(link && this.cartDrawer()) { e.preventDefault();this.openCart(); }
      }, options);
      this.querySelectorAll('[data-tq-sticky-buy]').forEach(b => b.addEventListener('click', () => {
        const form = this.querySelector('[data-tq-form]');
        if (form && !this.busy) form.requestSubmit();
      }, options));
      const modal = this.querySelector('.tq-modal');
      this.querySelector('[data-tq-close]')?.addEventListener('click', () => modal.close(), options);
      modal?.addEventListener('click', e => { if (e.target === modal) { const r=modal.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) modal.close(); } }, options);
      const sticky = this.querySelector('[data-tq-sticky]');
      const hero = this.querySelector('[data-tq-hero]');
      const final = this.querySelector('[data-tq-final] [data-tq-submit]');
      if (sticky && hero && 'IntersectionObserver' in window) {
        let pastHero = false, finalVisible = false;
        const update = () => sticky.classList.toggle('is-visible', pastHero && !finalVisible);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => { if (entry.target === hero) pastHero = !entry.isIntersecting && entry.boundingClientRect.bottom < 0; if(entry.target === final) finalVisible = entry.isIntersecting; });
          update();
        }, {threshold:0});
        this.observer.observe(hero); if(final) this.observer.observe(final);
      }
    }
    disconnectedCallback() {
      this.abort?.abort();this.observer?.disconnect();this.reviewObserver?.disconnect();
      clearInterval(this.reviewRetry);clearTimeout(this.reviewTimeout);clearTimeout(this.galleryTimer);this.galleryResize?.disconnect();this.initialized=false;
    }
    initGallery(options) {
      const gallery=this.querySelector('[data-tq-gallery]');
      if(!gallery) return;
      const track=gallery.querySelector('[data-tq-track]');
      const slides=[...track.querySelectorAll('[data-tq-slide]')];
      const thumbs=[...gallery.querySelectorAll('[data-tq-thumb]')];
      const prev=gallery.querySelector('[data-tq-prev]');
      const next=gallery.querySelector('[data-tq-next]');
      const count=gallery.querySelector('[data-tq-counter]');
      const caption=gallery.querySelector('[data-tq-caption]');
      const zoom=this.querySelector('[data-tq-zoom]');
      let index=0;
      const update=()=>{
        index=Math.max(0,Math.min(slides.length-1,Math.round(track.scrollLeft/Math.max(1,track.clientWidth))));
        thumbs.forEach((a,i)=>a.setAttribute('aria-current',String(i===index)));
        prev.disabled=index===0;next.disabled=index===slides.length-1;
        count.textContent=`${index+1} / ${slides.length}`;
        caption.textContent=slides[index].dataset.caption;
      };
      const go=(i)=>{
        const target=Math.max(0,Math.min(slides.length-1,i));
        track.scrollTo({left:target*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
      };
      gallery.querySelectorAll('[data-tq-js-only]').forEach(e=>e.hidden=false);
      thumbs.forEach((a,i)=>a.addEventListener('click',e=>{e.preventDefault();go(i)},options));
      prev.addEventListener('click',()=>go(index-1),options);
      next.addEventListener('click',()=>go(index+1),options);
      track.addEventListener('scroll',()=>{clearTimeout(this.galleryTimer);this.galleryTimer=setTimeout(update,80)}, {...options,passive:true});
      track.addEventListener('keydown',e=>{
        if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;
        e.preventDefault();go(e.key==='Home'?0:e.key==='End'?slides.length-1:index+(e.key==='ArrowRight'?1:-1));
      },options);
      if('ResizeObserver' in window){
        this.galleryResize=new ResizeObserver(()=>{track.scrollTo({left:index*track.clientWidth,behavior:'instant'});update()});
        this.galleryResize.observe(track);
      }
      const zoomButton=gallery.querySelector('[data-tq-zoom-open]');
      if(zoom && typeof zoom.showModal==='function'){
        zoomButton.addEventListener('click',()=>{
          const source=slides[index].querySelector('img');
          const target=zoom.querySelector('img');target.src=source.dataset.zoom||source.currentSrc||source.src;target.alt=source.alt;
          zoom.showModal();
        },options);
        zoom.querySelector('[data-tq-zoom-close]').addEventListener('click',()=>zoom.close(),options);
        zoom.addEventListener('click',e=>{if(e.target===zoom){const r=zoom.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)zoom.close()}},options);
      }else zoomButton.hidden=true;
      update();
    }

    syncRating(widget) {
      const badge=this.querySelector('[data-tq-rating-summary]');
      if(!badge) return;
      const summary=widget.querySelector('.wc_review_summary .wc_review_summary_count');
      const average=Number(summary?.querySelector('.wc_average_review_stars[data-avg]')?.dataset.avg?.replace(',','.'));
      const numbers=summary?.querySelector('.wc_review_summary_count_text')?.textContent.match(/\d(?:[\d.,\s\u00a0\u202f]*\d)?/g) || [];
      const token=numbers.length===1 ? numbers[0] : '';
      const count=/^(?:\d+|\d{1,3}(?:[.,\s\u00a0\u202f]\d{3})+)$/.test(token) ? Number(token.replace(/\D/g,'')) : 0;
      badge.hidden=!(Number.isFinite(average) && average>0 && average<=5 && Number.isSafeInteger(count) && count>0);
      if(badge.hidden) return;
      const label=`${average.toLocaleString('de-DE',{minimumFractionDigits:1,maximumFractionDigits:2})} / 5 · ${count.toLocaleString('de-DE')} ${count===1?'Bewertung':'Bewertungen'}`;
      badge.querySelector('[data-tq-rating-text]').textContent=label;
      badge.style.setProperty('--tq-rating-fill',`${average*20}%`);
      badge.setAttribute('aria-label',`${label}. Produktbewertungen ansehen`);
    }
    initReviews(options) {
      const section = this.querySelector('[data-tq-reviews]');
      const widget = section?.querySelector('#wc_review_section');
      if (!widget) return;
      const fallback = section.querySelector('[data-tq-review-fallback]');
      const status = section.querySelector('[data-tq-review-status]');
      // Reviews are owned and rendered by the existing Rivyo app embed.
      // Do not load a second vendor bundle, call private APIs or inject ratings.
      if (window.__TQ_PREVIEW__) {
        status.textContent = 'Gestaltungsvorschau: Hier lädt Rivyo im Shopify-Shop die aktuellen THE-QUEEN-Bewertungen.';
        return;
      }
      status.textContent = 'Produktbewertungen werden geladen …';
      const checkContent = () => {
        this.syncRating(widget);
        const content = widget.querySelector('.wc_review_widget, .wc_review_summary, .wc_empty_rivyo_text');
        if (!content || !content.textContent.trim()) return;
        fallback.hidden = true;
        section.dataset.reviewState = 'ready';
        clearInterval(this.reviewRetry);clearTimeout(this.reviewTimeout);
      };
      this.reviewObserver = new MutationObserver(checkContent);
      this.reviewObserver.observe(widget, { childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['data-avg'] });
      const mount = () => {
        // This entry point is present in the store's current Rivyo v2 bundle.
        // Its own mounted-root guard prevents a second React mount.
        if (typeof window.rivyoProductReviewBlock === 'function') {
          try { window.rivyoProductReviewBlock(); }
          catch (_) { /* Keep the product-page fallback if app setup is incomplete. */ }
        }
        checkContent();
      };
      document.addEventListener('DOMContentLoaded', mount, options);
      window.addEventListener('load', mount, options);
      document.addEventListener('load', e => {
        if (e.target?.tagName === 'SCRIPT' && /rivyo-script/.test(e.target.src || '')) mount();
      }, { ...options, capture:true });
      this.reviewRetry = setInterval(mount, 500);
      this.reviewTimeout = setTimeout(() => {
        clearInterval(this.reviewRetry);
        if (!fallback.hidden) {
          status.textContent = 'Die Bewertungen lassen sich hier gerade nicht laden.';
          section.dataset.reviewState = 'fallback';
        }
      }, 12000);
      mount();
    }
    cartDrawer() {
      const drawer=document.querySelector('cart-drawer#cart-drawer,cart-drawer');
      return drawer && typeof drawer.show==='function' ? drawer : null;
    }
    openCart() {
      const drawer=this.cartDrawer();
      if(!drawer) return false;
      this.querySelector('.tq-modal')?.close();
      drawer.show();
      return true;
    }
    showCartFeedback() {
      if(this.dataset.afterAdd==='cart') { window.location.assign(this.dataset.cart);return; }
      const modal=this.querySelector('.tq-modal');
      if(modal && typeof modal.showModal==='function') modal.showModal();
      else if(!this.openCart()) window.location.assign(this.dataset.cart);
    }
    async updateThemeCart(data,sections,form) {
      const response=await fetch(this.dataset.cart+'.js',{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden.');
      const cart=await response.json();
      if(!Number.isInteger(cart.item_count) || !Array.isArray(cart.items)) throw new Error('Ungültige Warenkorb-Antwort.');
      cart.sections=data.sections || {};
      const missing=sections.filter(id=>typeof cart.sections[id]!=='string' || !cart.sections[id].trim());
      if(missing.length) {
        const url=new URL(this.dataset.cart,window.location.origin);
        url.searchParams.set('sections',missing.join(','));
        const rendered=await fetch(url,{credentials:'same-origin',headers:{Accept:'application/json'},cache:'no-store'});
        if(!rendered.ok) throw new Error('Warenkorb-Ansicht konnte nicht aktualisiert werden.');
        Object.assign(cart.sections,await rendered.json());
      }
      if(sections.some(id=>typeof cart.sections[id]!=='string' || !cart.sections[id].trim())) throw new Error('Warenkorb-Ansicht fehlt.');
      // Update Prestige's cart in the background; the campaign owns the checkout popup.
      const onSuccessDo=null;
      form.dispatchEvent(new CustomEvent('variant:add',{bubbles:true,detail:{items:data.items || [data],cart,onSuccessDo}}));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change',{bubbles:true,detail:{baseEvent:'tq:cart-added',cart,onSuccessDo}}));
    }
    async addItem(form) {
      if(this.busy) return;
      this.busy = true;
      const buttons = [...this.querySelectorAll('[data-tq-submit],[data-tq-sticky-buy]')];
      buttons.forEach(b => { b.dataset.priorDisabled=String(b.disabled);b.disabled=true;b.setAttribute('aria-busy','true'); });
      const status=form.querySelector('[role=status]');status.textContent='Wird hinzugefügt …';
      let added=false;
      try {
        const requested=[];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections',{bubbles:true,detail:{sections:requested}}));
        const drawerSection=this.cartDrawer()?.closest('[id^="shopify-section-"]')?.id.replace('shopify-section-','');
        if(drawerSection) requested.push(drawerSection);
        const sections=[...new Set(requested)].slice(0,5);
        const body=new FormData(form);
        if(sections.length) { body.set('sections',sections.join(','));body.set('sections_url',window.location.pathname); }
        const response=await fetch(this.dataset.cartAdd + '.js', {method:'POST',body,credentials:'same-origin',headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});
        added=response.ok;
        const data=await response.json();
        if(!response.ok) throw new Error(typeof data.description === 'string' ? data.description : 'Der Artikel konnte nicht hinzugefügt werden. Bitte prüfe deinen Warenkorb.');
        status.textContent='The Queen wurde deinem Warenkorb hinzugefügt.';
        await this.updateThemeCart(data,sections,form);
        this.showCartFeedback();
        // Commerce tracking remains with the existing Shopify integration; no extra pixel.
        this.dispatchEvent(new CustomEvent('tq:cart-added',{bubbles:true,detail:{item:data}}));
      } catch(error) {
        if(added) {
          status.textContent='The Queen wurde hinzugefügt. Die Warenkorb-Anzeige wird neu geladen. Bitte nicht erneut hinzufügen.';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.showCartFeedback();
        } else status.textContent=error instanceof TypeError ? 'Die Verbindung wurde unterbrochen. Bitte prüfe zuerst deinen Warenkorb, bevor du erneut klickst.' : error.message;
        status.insertAdjacentHTML('beforeend',' <a data-tq-cart-recovery>Warenkorb öffnen</a>');
        status.querySelector('a').href=this.dataset.cart;
      } finally {
        this.busy=false;
        buttons.forEach(b=>{b.disabled=b.dataset.priorDisabled==='true';b.removeAttribute('aria-busy');delete b.dataset.priorDisabled;});
      }
    }
  });
}
